import Col from './Col/Col';
import Row from './Row/Row';
import Group from './Group/Group';

const Grid = {
  Col,
  Row,
  Group,
};

export default Grid;
